/** Project Root

material
└── components
    ├── componentName (Components are named with 'pl' in the begging. Ex: plButton)
        └── componentName.vue - Import index.styl, add scoped css and create vue template
    └── componentName (Every component should have its own folder)
        └── componentName.vue

└── core (These are imported by index.styl and are available to all components)
    ├── coreAnimations.styl - Base CSS ANIMATIONS
    ├── coreFunctions.styl - Base Stylus FUNCTIONS
    ├── coreThemes.styl - Base Colours THEMES
    └── coreTypography.styl - Base TYPOGRAPHY

└── index.js - Import all components and create a vue.install for each
└── index.styl - Import all .styl files from core folder

**/

import plButton from './components/plButton/plButton';
import plCard from './components/plCard/plCard';
import plCheckbox from './components/plCheckbox/plCheckbox';
import plDialog from './components/plDialog/plDialog';
import plDialogConfirm from './components/plDialog/plDialogConfirm';
import plInput from './components/plInput/plInput';
import plMenu from './components/plMenu/plMenu';
import plPreloader from './components/plPreloader/plPreloader';
import plRadio from './components/plRadio/plRadio';
import plSpinner from './components/plSpinner/plSpinner';
import plSelect from './components/plSelect/plSelect';
import plTabs from './components/plTabs/plTabs';
import { Multiselect } from 'vue-multiselect';
import vDropdown from './components/vDropdown/vDropdown';
import JwPagination from "./components/JwPagination/JwPagination.vue";

const ParlayMaterial = {
  install(Vue) {
    Vue.component('pl-button', plButton);
    Vue.component('pl-card', plCard);
    Vue.component('pl-checkbox', plCheckbox);
    Vue.component('pl-dialog', plDialog);
    Vue.component('pl-confirm', plDialogConfirm);
    Vue.component('pl-input', plInput);
    Vue.component('pl-menu', plMenu);
    Vue.component('pl-preloader', plPreloader);
    Vue.component('pl-radio', plRadio);
    Vue.component('pl-spinner', plSpinner);
    Vue.component('pl-select', plSelect);
    Vue.component('pl-tabs', plTabs);
    Vue.component('pl-multiselect', Multiselect);
    Vue.component('v-dropdown', vDropdown);
    Vue.component("jw-pagination", JwPagination);
  },
};

export default ParlayMaterial;



// WEBPACK FOOTER //
// ./src/app/components/material/index.js